import api from './api';

export const getDistrict = async () => {
  const response = await api.get('/common/district');
  return response.data;
};

export const getDistrictById = async (districtId) => {
  const response = await api.get(`/common/district/${districtId}`);
  return response.data;
};

export const getDistrictByCode = async (districtCode) => {
  const response = await api.get(`/common/district/code/${districtCode}`);
  return response.data;
};

export const getSubdistrict = async () => {
  const response = await api.get('/common/subdistrict');
  return response.data;
};

export const getSubdistrictById = async (subdistrictId) => {
  const response = await api.get(`/common/subdistrict/${subdistrictId}`);
  return response.data;
};

export const getSubdistrictByCode = async (subdistrictCode) => {
  const response = await api.get(`/common/subdistrict/code/${subdistrictCode}`);
  return response.data;
};

export const getSubdistrictByDistrict = async (districtId) => {
  const response = await api.get(`/common/subdistrict/districtid/${districtId}`);
  return response.data;
};

export const getRegions = async () => {
  const response = await api.get('/common/regions');
  return response.data;
};

export const getRegionsById = async (regionsId) => {
  const response = await api.get(`/common/district/${regionsId}`);
  return response.data;
};

export const getRegionsByCode = async (regionsCode) => {
  const response = await api.get(`/common/district/code/${regionsCode}`);
  return response.data;
};
